import React from "react";
import { Message } from "semantic-ui-react";
import MakePaymentModal from "../../invoice/makepayment/MakePaymentModal";
import { DeleteDialog, Modal } from "../../components";
import PaymentsTable from "../../invoice/makepayment/PaymentsTable";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import { useCustomQuery } from "utilities/hookutils";
import { Loading } from "components/panels";
import { isInvoiceOverude as isInvoiceOverdue } from "utilities/invoiceUtils";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
interface Props {
  invoice: server.dto.InvoiceV2
  paymentInfo?: server.dto.PaymentsForInvoice
  canModify: boolean

}

const PaymentsPanel = (props: Props) => {
  const { canModify } = props;

  const [editingPayment, setEditingPayment] = React.useState<server.dto.Payment | null>(undefined);
  const [deletingPayment, setDeletingPayment] = React.useState<server.dto.Payment>(undefined);

  const onNewPaymentClicked = () => {
    setEditingPayment(null);
  };

  const reloadIfNeeded = (payment: server.dto.PaymentsForInvoice) => {
    if (props.invoice.lifeCycle.value === "pending" && payment.outstanding.amount === 0) {
      window.location.reload();
    } else if (props.invoice.lifeCycle.value === "completed" && payment.outstanding.amount !== 0) {
      window.location.reload();
    }
  }

  const onPaymentSaved = async () => {
    setEditingPayment(undefined);
    const newResult = await paymentsApi.refetch();

    reloadIfNeeded(newResult.data);
  };

  const deletePayment = async (payment: server.dto.Payment) => {
    await window.CoreApi.Payment.Delete({ paymentId: payment.paymentId });
    setDeletingPayment(undefined);
    const res = await paymentsApi.refetch();
    reloadIfNeeded(res.data);
    return res;
  };

  const paymentsApi = useCustomQuery({
    queryKey: ["payments", props.invoice.documentId],
    queryFn: async () => window.Api.Invoices.ListPayments(props.invoice.documentId).then(r => r.data),
    enabled: props.paymentInfo == null,
    initialData: props.paymentInfo
  });

  if (paymentsApi.isInitialLoading) {
    return <SectionPanel.Panel
      header={<PanelSegmentType.Title title={RESX.Payment.Payments} />}
    >

      <Loading />
    </SectionPanel.Panel>;
  }

  const isSettled = paymentsApi.data.outstanding.amount === 0;

  return <SectionPanel.Panel
    header={<>
      <PanelSegmentType.Title title={RESX.Payment.Payments} />
      {canModify && <PanelSegmentType.Button onClick={onNewPaymentClicked} label={RESX.Buttons.btnNew} type="secondary" />}
    </>}
  >
    {paymentsApi.data.collection.length === 0 && <Message className="flex" color={isSettled ? undefined : "red"}>
      <div className="grow1">
        {RESX.Financial.Outstanding}
      </div>
      <div className="s1_cell_financialamount">
        {paymentsApi.data.outstanding.formatted}
      </div>
    </Message>}

    {paymentsApi.data.collection.length > 0 && <PaymentsTable
      isOverdue={isInvoiceOverdue(props.invoice)}
      payments={paymentsApi.data}
      onEdit={setEditingPayment}
      onDelete={setDeletingPayment}
      canModify={canModify}
    />}

    <Modal
      isOpen={editingPayment !== undefined}
      handleClose={() => { setEditingPayment(undefined); }}
      title={editingPayment == null ? RESX.Payment.NewPayment : RESX.Payment.EditPayment}
      width={"small"}
    >
      <MakePaymentModal
        invoiceId={props.invoice.documentId}
        onSaved={onPaymentSaved}
        outstandingAmount={paymentsApi.data.outstanding.amount}
        currency={props.invoice.currency.value}
        existingPayment={editingPayment}
      />
    </Modal>

    <DeleteDialog
      isOpen={deletingPayment != null}
      message={RESX.GeneralWarnings.DeleteSure}
      handleClose={() => { setDeletingPayment(undefined); }}
      onDelete={() => deletePayment(deletingPayment)}
    />
  </SectionPanel.Panel>;
};

export default PaymentsPanel;